export const ADD_FAVORITE_APP = 'ADD_FAVORITE_APP'
export const REMOVE_FAVORITE_APP = 'REMOVE_FAVORITE_APP'
export const INIT_FAVORITE_APP = 'INIT_FAVORITE_APP'
